import React, { useState } from 'react';
import PostStatusHelpDialog from './PostStatusHelpDialog';
import StatusBadge from '../../../DesignSystem/StatusBadge';
import useApiQuery from '../../../../Hooks/useApiQuery';
import queriesConfig from '../../../../Services/queriesConfig';

function PostStatus({ post }: any) {
  const { data: statuses = [] } = useApiQuery({
    query: queriesConfig.getPostStatus(post.id),
  });

  const [isDetailsDialogOpen, setDetailsDialogOpen] = useState(false);

  const handleDialogOpen = () => {
    setDetailsDialogOpen(true);
  };

  const handleDetailsDialogClose = () => {
    setDetailsDialogOpen(false);
  };

  return (
    <>
      {statuses && (
        <StatusBadge status={post.current_status} onClick={handleDialogOpen} size="medium" />
      )}

      {!!statuses.length && (
        <PostStatusHelpDialog
          currentStatus={post.current_status}
          statuses={statuses}
          open={isDetailsDialogOpen}
          onClose={handleDetailsDialogClose}
        />
      )}
    </>
  );
}

export default PostStatus;
